/* This example requires Tailwind CSS v2.0+ */

import type { User } from '@lib/graphql/generated';
import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import type { FC } from 'react';
import { AuthorCard } from '../../molecules/AuthorCard/AuthorCard';

export interface AuthorBoxProps
  extends PropsWithClassProps<'avatar' | 'heading' | 'description' | 'card' | 'title' | 'uplink'> {
  authors: User[];
}

export const AuthorBox: FC<AuthorBoxProps> = ({ classProps, authors }) => {
  return (
    <div className={classProps?.root}>
      {authors.map((author, index) => (
        <AuthorCard key={index} classProps={classProps} author={author} />
      ))}
    </div>
  );
};
